import React, { useEffect, useState } from "react";
import ImageAbout from "../../../assets/images/hero_about.webp";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function About() {
  const { t } = useTranslation();
  const [aboutData, setAboutData] = useState(null);
  const locale = useSelector((state) => state.locale.locale);
  useEffect(() => {
    setAboutData(t("home.about", { returnObjects: true }));
  }, [t, locale]);
  return (
    <div className="bg-black relative font-ttFirsNeue">
      <div className="grid md:grid-cols-2 min-h-full h-full text-white">
        <div className="place-content-center w-full md:pl-24 md:pr-10 px-10 py-10 uppercase space-y-2">
          <h1>{aboutData?.title}</h1>
          <h2 className="font-soulmaze  2xl:text-8xl md:text-6xl text-4xl italic !leading-relaxed text-[#F79838]">
            SEMARANG 10K
          </h2>
          <div className="space-y-5 normal-case font-ttFirsNeue font-light md:w-4/5 text-justify">
            <div
              className="space-y-5"
              dangerouslySetInnerHTML={{ __html: aboutData?.content }}
            ></div>
          </div>
        </div>
        <div className="md:place-content-end md:items-end md:justify-end md:flex">
          <img src={ImageAbout} alt="" className="w-full" />
        </div>
      </div>
    </div>
  );
}
